var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0V2H16.586L1.29297 17.293L2.70697 18.707L18 3.414V8H20V0H12Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.70697 7.70697L3.99997 5.41397L6.29297 7.70697L7.70697 6.29297L5.41397 3.99997L7.70697 1.70697L6.29297 0.292969L3.99997 2.58597L1.70697 0.292969L0.292969 1.70697L2.58597 3.99997L0.292969 6.29297L1.70697 7.70697Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11C14.61 11 13.74 11.2639 12.9999 11.7584C12.2599 12.2529 11.6831 12.9557 11.3425 13.7779C11.0019 14.6002 10.9128 15.505 11.0865 16.3779C11.2601 17.2508 11.6887 18.0526 12.318 18.682C12.9474 19.3113 13.7492 19.7399 14.6221 19.9135C15.495 20.0872 16.3998 19.9981 17.2221 19.6575C18.0443 19.3169 18.7471 18.7401 19.2416 18.0001C19.7361 17.26 20 16.39 20 15.5C19.9987 14.3069 19.5241 13.1631 18.6805 12.3195C17.8369 11.4759 16.6931 11.0013 15.5 11ZM15.5 18C15.0055 18 14.5222 17.8534 14.1111 17.5787C13.7 17.304 13.3795 16.9135 13.1903 16.4567C13.0011 15.9999 12.9516 15.4972 13.048 15.0123C13.1445 14.5273 13.3826 14.0819 13.7322 13.7322C14.0819 13.3826 14.5273 13.1445 15.0123 13.048C15.4972 12.9516 15.9999 13.0011 16.4567 13.1903C16.9135 13.3795 17.304 13.7 17.5787 14.1111C17.8534 14.5222 18 15.0055 18 15.5C18 16.163 17.7366 16.7989 17.2678 17.2678C16.7989 17.7366 16.163 18 15.5 18Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.37dd764be3ab9c5c3bf5fd321918cc16.svg";
export { ForwardRef as ReactComponent };